import {
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  BoldOutlined,
  ClearOutlined,
  ShrinkOutlined,
  ExpandOutlined,
  ItalicOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  UnderlineOutlined,
  RedoOutlined,
  UndoOutlined,
  RadiusSettingOutlined,
} from '@ant-design/icons';
import { Divider } from 'antd';
import { ToolbarButton } from './button';
import { FontSize } from './font-size';
import { FullScreenButton } from './full-screen';
import { TableSelector } from './table-selector';

interface Props {
  editor: any;
  onFullScreen: () => void;
  isFullScreen: boolean;
}

export const EditorToolbar: React.FC<Props> = (props) => {
  const { editor, onFullScreen, isFullScreen } = props;

  return (
    <div className="tw-flex tw-gap-1 tw-flex-wrap tw-h-full tw-items-center tw-p-1 tw-border-[1px] tw-border-b-0 tw-border-[#ccced1] dark:tw-border-[#424242]">
      <ToolbarButton
        editor={editor}
        commandName="undo"
        icon={<UndoOutlined />}
        tooltip="Undo"
      />
      <ToolbarButton
        editor={editor}
        commandName="redo"
        icon={<RedoOutlined />}
        tooltip="Redo"
      />
      <Divider type="vertical" />

      <FontSize editor={editor} />

      <Divider type="vertical" />
      <ToolbarButton
        editor={editor}
        commandName="bold"
        icon={<BoldOutlined />}
        tooltip="Bold"
        isToggleButton
      />
      <ToolbarButton
        editor={editor}
        commandName="italic"
        icon={<ItalicOutlined />}
        tooltip="Italic"
        isToggleButton
      />
      <ToolbarButton
        editor={editor}
        commandName="underline"
        icon={<UnderlineOutlined />}
        tooltip="Underline"
        isToggleButton
      />
      <Divider type="vertical" />
      <ToolbarButton
        editor={editor}
        commandName="alignment"
        commandValue="left"
        icon={<AlignLeftOutlined />}
        tooltip="Left Align"
        isToggleButton
      />
      <ToolbarButton
        editor={editor}
        commandName="alignment"
        commandValue="center"
        icon={<AlignCenterOutlined />}
        tooltip="Center Align"
        isToggleButton
      />
      <ToolbarButton
        editor={editor}
        commandName="alignment"
        commandValue="right"
        icon={<AlignRightOutlined />}
        tooltip="Right Align"
        isToggleButton
      />
      <ToolbarButton
        editor={editor}
        commandName="alignment"
        commandValue="justify"
        icon={<RadiusSettingOutlined />}
        tooltip="Justify Text"
        isToggleButton
      />

      <Divider type="vertical" />

      <ToolbarButton
        editor={editor}
        commandName="bulletedList"
        icon={<OrderedListOutlined />}
        tooltip="Bullet List"
        isToggleButton
      />
      <ToolbarButton
        editor={editor}
        commandName="numberedList"
        icon={<UnorderedListOutlined />}
        tooltip="Number List"
        isToggleButton
      />

      <Divider type="vertical" />

      <ToolbarButton
        editor={editor}
        commandName="outdent"
        icon={<ShrinkOutlined />}
        tooltip={'Outdent'}
      />
      <ToolbarButton
        editor={editor}
        commandName="indent"
        icon={<ExpandOutlined />}
        tooltip={'Indent'}
      />

      <Divider type="vertical" />

      <TableSelector editor={editor} />

      <Divider type="vertical" />

      <ToolbarButton
        editor={editor}
        commandName="removeFormat"
        icon={<ClearOutlined />}
        tooltip="Remove Formatting"
      />

      <Divider type="vertical" />
      <FullScreenButton onClick={onFullScreen} isActive={isFullScreen} />
    </div>
  );
};
